/**
 * Common endpoints used in the application
 * Endpoints which doesnot fit in any other category or specific to any module
 */
export const COMMON_ENDPOINT = {
  TRACK_VARICON_KNOWLEDGE: '/v1.1/track_varicon_knowledge/',
  STATE: '/state/',
  COUNTRY: '/mobile/supplier/country/',
  GET_EQUIPMENTS_DROPDOWN: '/v1.1/get/equipment/',
  STONLY: '/v1.1/stonly/',
  GET_TENANTS: '/v1.1/tenant/',
};

export const TAX_SETTINGS_ENDPOINTS = {
  GET_TAX_SETTINGS_DROPDOWN: '/v1.1/api-bills/dropdown/tax_list/',
};

export const TASK_ENDPOINTS = {
  GET_TASK_DROPDOWN: 'v1.1/api-bills/dropdown/tasks',
};

export const COMMENT_ENDPOINTS = {
  GET_COMMENTS: '/bills/comment/list/',
  CREATE_COMMENT: '/bills/comment/create/',
  UPDATE_COMMENT: '/bills/comment/update/',
  DELETE_COMMENT: '/bills/comment/delete/',
};

export const FILTER_PERSIST_API = '/v1.1/user-persist/';
